import React from "react";
import { Seo } from "../components/Seo";
import { Reveal, SectionHeader } from "../components/site/Reveal";
import { BookingForm } from "../components/site/Contact";
import { Faq } from "../components/site/Faq";
import { FAQ } from "../lib/content";

export default function ContactPage() {
  return (
    <>
      <Seo title="Contact & Book" description="Book SPECA Detailing in Melbourne. Request a quote or booking — our team will confirm availability and final pricing." path="/contact" />
      <section className="pt-28 pb-4 md:pt-36">
        <div className="max-w-7xl mx-auto px-6 lg:px-8">
          <Reveal><span className="overline">Contact & Booking</span></Reveal>
          <Reveal delay={0.06}><h1 className="font-display text-4xl md:text-6xl font-bold tracking-tight mt-4 leading-[1.05]">Your vehicle <span className="text-silver">deserves the best.</span></h1></Reveal>
          <Reveal delay={0.12}><p className="text-gray-400 font-light mt-5 max-w-2xl">Get in touch with SPECA Detailing for professional automotive care.</p></Reveal>
        </div>
      </section>
      <BookingForm />
      <Faq items={FAQ} overline="FAQ" title="Common questions." />
    </>
  );
}
